<template>
  <vf-breadcrumbs
    v-if="product"
    v-style:display="{
      sm: $feature.breadcrumbVisibilityOnPDP?.sm ? 'flex' : 'none',
      md: $feature.breadcrumbVisibilityOnPDP?.md ? 'flex' : 'none',
      lg: $feature.breadcrumbVisibilityOnPDP?.lg ? 'flex' : 'none',
    }"
    :class="[brandClasses.breadcrumbs, { '!hidden': hideBreadcrumbs }]"
    :items="product.breadcrumbs || []"
    :max-items="breadcrumbsMaxItems"
  />
</template>

<script lang="ts" setup>
const { brandClasses, breadcrumbsMaxItems, hideBreadcrumbs } = useAppConfig().pages.pdp
const { product } = usePdp()
</script>
